import api from './api'
import { API_ENDPOINTS } from '../config/api'

// Third Party Game Limit — owner-only. The server refuses both endpoints for
// staff/executive sessions (requireOwner); the sidebar and OWNER_ONLY_ROUTES
// hide the screen on the client.
const thirdPartyLimitService = {
  // Direct downline (staff + users) of the logged-in owner, or — with
  // parentId — of that staff. Each row carries own_limit (what was typed on
  // that row) and effective_limit (what is actually in force, inherited when
  // the row has none of its own).
  getList: async ({ page = 1, limit = 50, search = '', parentId = null } = {}) => {
    const params = { page, limit }
    if (search) params.search = search
    if (parentId) params.parentId = parentId
    const response = await api.get(API_ENDPOINTS.THIRD_PARTY_LIMIT.LIST, { params })
    return response.data
  },

  // { holder_type: 'OWNER'|'STAFF'|'USER', holder_id, max_amount }
  // max_amount 0 clears the row — that account then follows the limit set above it.
  setLimit: async (payload) => {
    const response = await api.post(API_ENDPOINTS.THIRD_PARTY_LIMIT.SET, payload)
    return response.data
  },
}

export default thirdPartyLimitService
